export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20warm%20glowing%20gradients%20of%20deep%20orange%20and%20gold%2C%20soft%20out%20of%20focus%20theater%20lights%2C%20elegant%20film%20projector%20light%20rays%2C%20dark%20rich%20texture%2C%20luxurious%20cinema%20atmosphere%2C%20no%20people%2C%20clean%20minimalist%20composition%2C%20professional%20photography&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="91视频网站背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16 py-10 md:py-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs md:text-sm font-medium mb-4 md:mb-5">
              每日更新 · 高清免费 · 正版片库
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-background-50 font-heading leading-tight mb-3 md:mb-4">
              91视频网站<span className="block md:inline"> · </span>全网影视免费在线观看
            </h1>

            <p className="text-base md:text-lg text-primary-400 font-semibold mb-5 md:mb-6">
              电影 · 电视剧 · 综艺 · 动漫 · 纪录片 — 你想看的，这里都有
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-6 md:mb-8 max-w-xl mx-auto lg:mx-0">
              91视频网站汇聚海量高清影视资源，覆盖院线大片、热门剧集、爆款综艺与优质国漫，每日不间断更新最新内容。无论你是追剧党、影迷还是综艺控，这里都能满足你对精彩影视的所有期待。平台采用智能推荐引擎，越看越懂你的口味，让每一次打开都是一场惊喜的发现之旅。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7 md:mb-9">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-sm text-background-100">5000万+注册用户</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-sm text-background-100">10万+影视资源</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-400"></div>
                <span className="text-sm text-background-100">每日更新零延迟</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm md:text-base rounded-lg hover:bg-primary-600 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                立即探索热播榜单
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-medium text-sm md:text-base rounded-lg hover:bg-background-50/25 transition-all text-center whitespace-nowrap cursor-pointer border border-background-50/20"
              >
                下载APP随时看
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/30">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20collage%20with%20warm%20golden%20and%20orange%20tones%2C%20elegant%20movie%20scene%20compositions%20blended%20artistically%2C%20theater%20curtain%20texture%2C%20film%20reel%20elements%2C%20luxurious%20cinema%20atmosphere%2C%20professional%20movie%20poster%20design%2C%20dramatic%20lighting%2C%20clean%20dark%20background%20with%20warm%20accents&width=1000&height=700&seq=hero-visual-main&orientation=portrait"
                alt="91视频 - 海量影视内容"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 md:p-5">
                <div className="flex items-center gap-3 text-background-50">
                  <div className="w-10 h-10 rounded-full bg-primary-500/80 flex items-center justify-center">
                    <i className="ri-play-fill text-xl"></i>
                  </div>
                  <span className="text-sm font-medium">热门影视 · 即刻畅享</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}